module.exports = __webpack_public_path__ + "img/congrate.222bf077.png";